import axios from "services/axios";

export const biddingStatuses = () => async dispatch => {
  dispatch(BiddingStatusRequest());

  try {
    const request = await axios.get("/car-inquiry/inquiry-statuses");
    return dispatch(biddingStatusRequestSuccess(request.data));
  } catch (err) {
    return dispatch(biddingStatusRequestFailed(err));
  }
};

export const BiddingStatusRequest = () => {
  return {
    type: "BIDDING_STATUS_REQUEST",
  };
};

export const biddingStatusRequestSuccess = payload => {
  return {
    type: "BIDDING_STATUS_REQUEST_SUCCESS",
    payload,
  };
};

export const biddingStatusRequestFailed = err => {
  return {
    type: "BIDDING_STATUS_REQUEST_FAILED",
    payload: err,
  };
};



// WEBPACK FOOTER //
// src/store/actions/bidding.js